// extracted by mini-css-extract-plugin
export default {"coronavirusFAQ":"coronavirusFAQ"};